import { render, staticRenderFns } from "./ProductReagent.vue?vue&type=template&id=82d3a904&scoped=true&"
import script from "./ProductReagent.vue?vue&type=script&lang=js&"
export * from "./ProductReagent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "82d3a904",
  null
  
)

export default component.exports